module.exports = __webpack_public_path__ + "img/avatar-matthew-eng.6ef06cda.jpg";